import { ItemVM } from 'shell/view-models/item';

export const CODE_STATE_REJECTED = '24';

export const CodeStateArchiveAnnotations: Array<ItemVM> = [
  {
    id: '21',
    value: 'Da stampare',
  },
  {
    id: '22',
    value: 'Stampata',
  },
  {
    id: '23',
    value: 'Annotata',
  },
  {
    id: '24',
    value: 'Rifiutata',
  },
];

export const nameCodeStateArchiveAnnotations = (id: string): string => {
  return CodeStateArchiveAnnotations.find((el) => el.id === id)?.value || '';
};
